import { useMutation, useQueryClient } from '@tanstack/react-query'

import { dataOrThrow, type PostSubscriptionUpgradeBody } from '@snootsvet/shared/portal'

import { usePortalApi } from '@/customer/hooks/use-api'
import { meQueryKey } from '@/customer/hooks/use-get-me'
import { petSubscriptionQueryKey } from '@/customer/hooks/use-get-pet-subscription'
import { subscriptionUpgradeQueryKey } from '@/customer/hooks/use-get-subscription-upgrade'
import { invoicesQueryKey } from '@/customer/hooks/use-list-invoices'

/**
 * Upgrades a pet's subscription to a longer-duration plan via
 * `POST /api/portal/pets/:id/subscription/upgrade`.
 */
export function usePostSubscriptionUpgrade(patientId: string) {
  const api = usePortalApi()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (body: PostSubscriptionUpgradeBody) =>
      dataOrThrow(
        await api.post('/pets/:id/subscription/upgrade', { params: { id: patientId }, body })
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: meQueryKey })
      queryClient.invalidateQueries({ queryKey: petSubscriptionQueryKey(patientId) })
      queryClient.invalidateQueries({ queryKey: subscriptionUpgradeQueryKey(patientId) })
      queryClient.invalidateQueries({ queryKey: invoicesQueryKey() })
    },
  })
}
